let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6nK39")).then(() => parcelRequire('3GtCy'));